import type { StatusTone } from '../../../ui-kit';
import type { McStatus } from '../../../services/missedCallService';

/** The chip a call wears, in every list and in its story. */
const CHIPS: Record<McStatus, { tone: StatusTone; label: string }> = {
  ringing: { tone: 'good', label: 'Ringing' },
  answered: { tone: 'good', label: 'Taken by the team' },
  message_held: { tone: 'warning', label: 'Waiting for approval' },
  message_sent: { tone: 'neutral', label: 'No reply yet' },
  replied: { tone: 'neutral', label: 'Client replied' },
  callback_booked: { tone: 'good', label: 'Callback booked' },
  needs_person: { tone: 'warning', label: 'Needs a person' },
  stopped: { tone: 'neutral', label: 'Asked us to stop' },
};

export function statusChip(status: McStatus): { tone: StatusTone; label: string } {
  return CHIPS[status] ?? { tone: 'neutral', label: status };
}
